export const caseInsensitiveFuzzySearch = (query: string, keys: Array<string | null | undefined>): boolean => !query || keys
  .map(k => (k ?? '').toLowerCase())
  .some(k => k.includes(query.toLowerCase()));
